<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden">

      <router-link v-if="!item.meta.isDropDown&&!item.alwaysShow"
                   :to="item.path+'/'+item.children[0].path" :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <i v-if="item.children[0].meta&&item.children[0].meta.icon"
             v-bind:class="item.children[0].meta.icon"> </i>
          <span v-if="item.children[0].meta&&item.children[0].meta.title"
                slot="title">{{ item.children[0].meta.title }}</span>
        </el-menu-item>
      </router-link>
      <el-submenu v-else :index="item.name||item.path" :key="item.name">

        <template slot="title">
          <i v-if="item.meta&&item.meta.icon"
             v-bind:class="item.meta.icon"> </i>
          <span v-if="item.meta&&item.meta.title"> {{item.meta.title}}</span>
        </template>

        <div v-loading="projectListLoading">
          <template v-for="project in projects">
            <router-link :to="'/project/index/'+project.id" :key="project.id">
              <el-menu-item :index="project.id"> {{project.name}}
              </el-menu-item>
            </router-link>
          </template>
        </div>
        <template v-if="item.name==='projects'">
          <el-menu-item class="create-new-project" index="create-new-project"><i class="icon-add"></i> Create new
            project
          </el-menu-item>
        </template>

      </el-submenu>


    </template>

  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import errorMixin from '../../../mixins/errorMixin'

  export default {
    mixins: [errorMixin],

    name: 'SidebarItem',
    created() {
      this.projectListLoading = true;
      this.$store.dispatch('getProjects').then(success => {
        this.projectListLoading = false;
      }).catch(error => {
        this.showError('unable to get projects ' + error);
      })
    }, data() {
      return {
        projectListLoading: false,
      }
    },
    props: {
      routes: {
        type: Array
      },
      isNest: {
        type: Boolean,
        default: false
      },

    },
    methods: {
      hasOneShowingChildren(children) {
        const showingChildren = children.filter(item => {
          return !item.hidden
        })
        if (showingChildren.length === 1) {
          return true
        }
        return false
      },


    },

    computed: {
      ...mapGetters(['projects'])
    }

  }
</script>
<style lang="scss" scoped>
  @import "../../../../styles/variables.scss";

  .el-menu-item {
    background: transparent !important;
  }

  .menu-wrapper {

    a {
      &.router-link-exact-active {
        border-right: 6px $blue solid;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
      }

      margin-top: 1px;
      background: $darkTransparent;
      li {
        color: $white !important;
        i {
          font-size: 1.4em;
          margin-right: 8px;
        }
        &:focus {
          background-color: transparent;
        }
        &:hover {
          background: transparent;
        }

      }

      &:hover {
        background: $darkTransparentSoft;
      }
    }

  }

  .create-new-project {
    color: white;
  }

</style>




// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SideBarItem.vue